import { useCallback, useMemo } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';
export const useToggleComponent = name => {
  const {
    isOpen,
    setComponentState,
    onComponentStatesMapChange
  } = useNavComponentsManager();
  const toggle = useCallback(shouldOpen => {
    const isCurrentlyOpen = isOpen(name);
    const nextValue = typeof shouldOpen === 'undefined' ? !isCurrentlyOpen : shouldOpen;
    setComponentState(name, currentState => Object.assign({}, currentState, {
      isOpen: nextValue,
      isLoaded: true
    }));
  }, [isOpen, name, setComponentState]);
  const onToggle = useCallback(subscriber => onComponentStatesMapChange(subscriber, ({
    [name]: {
      isOpen: isCurrentlyOpen
    }
  }) => isCurrentlyOpen), [name, onComponentStatesMapChange]);
  return useMemo(() => ({
    toggle,
    onToggle
  }), [onToggle, toggle]);
};